import * as R from 'Router/routes';
import loadable from '@loadable/component';

export const AsyncBundleFAQ = loadable(
  () => import('pages/BundleFAQ/BundleFAQ'),
);

export const AsyncDana = loadable(() => import('pages/Dana/Dana'));

export const AsyncBundleVivusPlusBenefits = loadable(
  () => import('pages/VivusPlusBenefits/VivusPlusBenefits'),
);

export const AsyncBundleNoConfirmed = loadable(
  () => import('pages/BundleNoConfirmed/BundleNoConfirmed'),
);

export const AsyncBundleConfirmed = loadable(
  () => import('pages/BundleConfirmed/BundleConfirmed'),
);

export const AsyncVivusPlusOffer = loadable(
  () => import('pages/VivusPlusOffer/VivusPlusOffer'),
);

export const AsyncOneTimeTokenLogin = loadable(
  () => import('pages/Login/OneTimeTokenLogin'),
);

export const AsyncBestOffer = loadable(
  () => import('pages/BestOffer/BestOffer'),
);

export const AsyncLogin = loadable(() => import('pages/Login/Login'));

export const AsyncChangePhoneTwoFactorAuth = loadable(
  () => import('pages/TwoFAChangePhone/TwoFAChangePhone'),
);

export const AsyncTwoFactorAuth = loadable(
  () => import('pages/Login/TwoFactorAuth'),
);

export const AsyncTwoFAPhoneError = loadable(
  () => import('pages/TwoFAPhoneError/TwoFAPhoneError'),
);

export const AsyncTwo2FAPhoneModified = loadable(
  () => import('pages/TwoFAPhoneModified/TwoFAPhoneModified'),
);

export const AsyncActiveLoan = loadable(
  () => import('pages/ActiveLoan/ActiveLoan'),
);
export const AsyncRepeatedLoan = loadable(
  () => import('pages/RepeatedLoan/RepeatedLoan'),
);
export const AsyncLoanConfirm = loadable(
  () => import('pages/LoanConfirm/LoanConfirm'),
);
export const AsyncRepayment = loadable(
  () => import('pages/Repayment/Repayment'),
);
export const AsyncFullRepayment = loadable(
  () => import('pages/FullRepayment/FullRepayment'),
);
export const AsyncRepaymentWireTransfer = loadable(
  () => import('pages/RepaymentWireTransfer/RepaymentWireTransfer'),
);
export const AsyncExtensions = loadable(
  () => import('pages/Extensions/Extensions'),
);
export const AsyncExtensionPayment = loadable(
  () => import('pages/ExtensionPayment/ExtensionPayment'),
);
export const AsyncExtensionSuccess = loadable(
  () => import('pages/ExtensionSuccess/ExtensionSuccess'),
);

export const AsyncRejectedOrFailure = loadable(
  () => import('pages/RejectedOrFailure/RejectedOrFailure'),
);

export const AsyncCardPayment = loadable(
  () => import('pages/CardPayment/CardPayment'),
);

export const AsyncCardPaymentConsSuccess = loadable(
  () => import('pages/CardPayment/CardPaymentStatus/Cons/ConsSuccess'),
);

export const AsyncCardPaymentMiniSuccess = loadable(
  () => import('pages/CardPayment/CardPaymentStatus/Mini/MiniSuccess'),
);

export const AsyncCheckDocuments = loadable(
  () => import('pages/CheckDocuments/CheckDocuments'),
);

export const AsyncLoanCheckDetails = loadable(
  () => import('pages/LoanCheckDetails/LoanCheckDetails'),
);

export const AsyncLoanCheckDetailsInsurance = loadable(
  () => import('pages/LoanCheckDetailsInsurance/LoanCheckDetailsInsurance'),
);

export const AsyncAdditionalAmount = loadable(
  () => import('pages/AdditionalAmount/AdditionalAmount'),
);

export const AsyncDocumentsPending = loadable(
  () => import('pages/DocumentsPending/DocumentsPending'),
);

export const AsyncDocumentsPendingUpload = loadable(
  () => import('pages/DocumentsPendingUpload/DocumentsPendingUpload'),
);

export const AsyncDocumentsApproved = loadable(
  () => import('pages/DocumentsApproved/DocumentsApproved'),
);

export const AsyncProfile = loadable(() => import('pages/Profile/Profile'));

export const AsyncExtensionCardPayment = loadable(
  () => import('pages/ExtensionCardPayment/ExtensionCardPayment'),
);

export const AsyncLoanApproved = loadable(
  () => import('pages/LoanApproved/LoanApproved'),
);

export const AsyncLoanApproved_v2 = loadable(
  () => import('pages/LoanApproved/LoanApproved_v2'),
);

export const AsyncPasswordChangeSuccess = loadable(
  () => import('pages/PasswordChangeSuccess/PasswordChangeSuccess'),
);

export const AsyncChangeTemporaryPassword = loadable(
  () => import('pages/ChangeTemporaryPassword/ChangeTemporaryPassword'),
);

export const AsyncNotFound = loadable(() => import('pages/NotFound/NotFound'));

export const AsyncNewsConsent = loadable(
  () => import('pages/NewsConsent/NewsConsent'),
);

export const AsyncSelektraPage = loadable(
  () => import('pages/SelektraPage/SelektraPage'),
);

export const AsyncFAQ = loadable(() => import('pages/FAQ/FAQ'));

export const AsyncPasswordChange = loadable(
  () => import('pages/PasswordChange/PasswordChange'),
);

export const AsyncPasswordRecovery = loadable(
  () => import('pages/PasswordRecovery/PasswordRecovery'),
);

export const AsyncSignDrAgreement = loadable(
  () => import('pages/SignDrAgreement/SignDrAgreement'),
);

export const AsyncSignDrAgreementSuccess = loadable(
  () => import('pages/SignDrAgreementSuccess/SignDrAgreementSuccess'),
);

export const AsyncPasswordRecoverySuccess = loadable(
  () => import('pages/PasswordRecoverySuccess/PasswordRecoverySuccess'),
);

export const AsyncSaveCard = loadable(() => import('pages/SaveCard/SaveCard'));

export const AsyncAutoRepay = loadable(
  () => import('pages/AutoRepay/AutoRepay'),
);

export const AsyncCardPaymentOverdueBrokenLoan = loadable(
  () =>
    import('pages/CardPaymentOverdueBrokenLoan/CardPaymentOverdueBrokenLoan'),
);

export const AsyncBreakdownDebt = loadable(
  () => import('pages/BreakdownDebt/BreakdownDebt'),
);

export const AsyncInstallmentPayment = loadable(
  () => import('pages/InstallmentPayment/InstallmentPayment'),
);

export const AsyncDROffer = loadable(
  () => import('pages/DebtRestructuringScreen/Offer/Offer'),
);

export const AsyncDROverdue = loadable(
  () => import('pages/DebtRestructuringScreen/DROverdue/DROverdue'),
);

export const AsyncDRPayment = loadable(
  () => import('pages/DRPayment/DRPayment'),
);

export const AsyncDROfferAccepted = loadable(
  () => import('pages/DebtRestructuringScreen/OfferAccepted/OfferAccepted'),
);

export const AsyncDRPaymentSchedule = loadable(
  () =>
    import('pages/DRPaymentSchedule/DRPaymentScheduleV1/DRPaymentScheduleV1'),
);

export const AsyncUnsubscribePage = loadable(
  () => import('../pages/UnsubscribePage/UnsubscribePage'),
);

export const AsyncRejectedTimer = loadable(
  () => import('../pages/RejectedTimer/RejectedTimer'),
);

export const AsyncInsurancePolicy = loadable(
  () => import('../pages/InsurancePolicy/InsurancePolicy'),
);

export const urlBundlePreloadHashMap: any = {
  [R.LOGIN]: AsyncLogin.preload,
  [R.TWO_FACTOR_AUTH]: AsyncTwoFactorAuth.preload,
  [R.TWO_2FA_PHONE_ERROR]: AsyncTwoFAPhoneError.preload,
  [R.ONLINE_LOGIN]: AsyncLogin.preload,
  [R.LOAN_CONFIRM]: AsyncLoanConfirm.preload,
  [R.ACTIVE_LOAN]: AsyncActiveLoan.preload,
  [R.PROFILE]: AsyncProfile.preload,
  [R.REPEATED_LOAN]: AsyncRepeatedLoan.preload,
  [R.REPAYMENT]: AsyncRepayment.preload,
  [R.FULL_REPAYMENT]: AsyncFullRepayment.preload,
  [R.EXTENSIONS]: AsyncExtensions.preload,
  [R.EXTENSION_PAYMENT]: AsyncExtensionPayment.preload,
  [R.EXTENSION_SUCCESS]: AsyncExtensionSuccess.preload,
  [R.EXTENSION_REJECTED]: AsyncRejectedOrFailure.preload,
  [R.EXTENSION_LIMITS_REJECTED]: AsyncRejectedOrFailure.preload,
  [R.CARD_PAYMENT]: AsyncCardPayment.preload,
  [R.CARD_PAYMENT_CONS_SUCCESS]: AsyncCardPaymentConsSuccess.preload,
  [R.CARD_PAYMENT_CONS_FAILURE]: AsyncRejectedOrFailure.preload,
  [R.CARD_PAYMENT_MINI_SUCCESS]: AsyncCardPaymentMiniSuccess.preload,
  [R.CARD_PAYMENT_FAILURE]: AsyncRejectedOrFailure.preload,
  [R.CHECK_DOCUMENTS]: AsyncCheckDocuments.preload,
  [R.LOAN_CHECK_DETAILS]: AsyncLoanCheckDetails.preload,
  [R.LOAN_CHECK_DETAILS_INSURANCE]: AsyncLoanCheckDetailsInsurance.preload,
  [R.DOCUMENTS_APPROVED]: AsyncDocumentsApproved.preload,
  [R.DOCUMENTS_PENDING]: AsyncDocumentsPending.preload,
  [R.EXTENSION_WITH_CARD]: AsyncExtensionCardPayment.preload,
  [R.ADDITIONAL_AMOUNT]: AsyncAdditionalAmount.preload,
  [R.ADDITIONAL_AMOUNT_REJECTED]: AsyncRejectedOrFailure.preload,
  [R.ADDITIONAL_AMOUNT_APPROVED]: AsyncLoanApproved.preload,
  [R.ADDITIONAL_AMOUNT_FAILED]: AsyncRejectedOrFailure.preload,
  [R.FAQ]: AsyncFAQ.preload,
  [R.CHANGE_TEMPORARY_PASSWORD]: AsyncChangeTemporaryPassword.preload,
  [R.NEWS_CONSENT]: AsyncNewsConsent.preload,
  [R.SAVE_CARD_MAIN]: AsyncSaveCard.preload,
  [R.AUTOREPAY_MAIN]: AsyncAutoRepay.preload,
  [R.SAVE_CARD_ADDITIONAL]: AsyncSaveCard.preload,
  [R.AUTOREPAY_ADDITIONAL]: AsyncAutoRepay.preload,
  [R.REPAYMENT_BROKEN_LOAN]: AsyncCardPaymentOverdueBrokenLoan.preload,
  [R.BREAKDOWN_DEBT]: AsyncBreakdownDebt.preload,
  [R.INSTALLMENT_PAYMENT]: AsyncInstallmentPayment.preload,
  [R.DR_OFFER]: AsyncDROffer.preload,
  [R.DR_OVERDUE]: AsyncDROverdue.preload,
  [R.DR_PAYMENT]: AsyncDRPayment.preload,
  [R.DR_OFFER_ACCEPTED]: AsyncDROfferAccepted.preload,
  [R.DR_PAYMENT_SCHEDULE]: AsyncDRPaymentSchedule.preload,
  [R.LOAN_REJECTED]: AsyncRejectedOrFailure.preload,
  [R.LOAN_FAILED]: AsyncRejectedOrFailure.preload,
  [R.CARD_PAYMENT_REJECTED_DUE_DUPLICATE]: AsyncRejectedOrFailure.preload,
  [R.EXTENSION_CARD_PAYMENT_REJECTED_DUE_DUPLICATE]:
    AsyncRejectedOrFailure.preload,
  [R.DANA]: AsyncDana.preload,
  [R.BUNDLE_VIVUSPLUS_OFFER]: AsyncVivusPlusOffer.preload,
  [R.BUNDLE_VIVUSPLUS_PENDING]: AsyncVivusPlusOffer.preload,
  [R.BUNDLE_VIVUSPLUS_CONFIRMED]: AsyncBundleConfirmed.preload,
  [R.BUNDLE_VIVUSPLUS_CONFIRMED_AA]: AsyncBundleConfirmed.preload,
  [R.BUNDLE_VIVUSPLUS_NO_CONFIRMED]: AsyncBundleNoConfirmed.preload,
  [R.BUNDLE_VIVUSPLUS_BENEFITS]: AsyncBundleVivusPlusBenefits.preload,
  [R.BUNDLE_VIVUSPLUS_FAQ]: AsyncBundleFAQ.preload,
  [R.INSURANCE_POLICY]: AsyncInsurancePolicy.preload,
};
